export default "/images/8db8a0c28c29aaaddb087390140aa348.avif";